// extracted by mini-css-extract-plugin
export default {"subscribe":"SubscribeService_subscribe__jCcm7"};